// Administration: routes the sidebar section to its page.
import React from 'react';
import { useRoute } from '../store';
import { AiPage } from './admin/Ai';
import { AttributesPage } from './admin/Attributes';
import { ListsPage } from './admin/Lists';
import { TypesPage } from './admin/Types';
import { UsersPage } from './admin/Users';
import { OrgChartPage } from './admin/OrgChart';
import { OcrAdminPage } from './admin/Ocr';
import { MailPage } from './admin/Mail';
import { SignatureAdminPage } from './admin/Signature';
import { MapsAdminPage } from './admin/Maps';

export function Admin({ section }: { section: string }) {
  const route = useRoute();
  switch (section) {
    case 'attributes': return <AttributesPage />;
    case 'lists': return <ListsPage />;
    case 'users': return <UsersPage />;
    case 'org': return <OrgChartPage />;
    case 'ai': return <AiPage />;
    case 'ocr': return <OcrAdminPage />;
    case 'mail': return <MailPage />;
    case 'sign': return <SignatureAdminPage />;
    case 'maps': return <MapsAdminPage />;
    default: { const open = Number(route.params.get('open')); return <TypesPage openId={open || null} />; }
  }
}
